module.exports = __webpack_public_path__ + "images/backgrounds/snow/full.8e45c8f13adf55afdaba.jpg";